import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {IMedium} from '../interfaces';
import {MediumService} from '../services';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class MediumsResolverService implements Resolve<IMedium[]> {

    constructor(private mediumService: MediumService) {
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<IMedium[]> {
        return this.mediumService.getMediums({}).pipe(map(data => data.results));
    }
}
